import { __assign, __extends } from "tslib";
import React, { Fragment } from 'react';
import { Image, Platform, TouchableOpacity, View } from 'react-native';
import { AppActions as Actions, BannerView, PnmacCard, PnmacCardActions, PnmacCardContent, PnmacCardTitle, PnmacHtmlToNative, PnmacImage, PnmacMediaQuery, PnmacMeta, PnmacNavigation, PnmacParagraph, PnmacText, PnmacUIButton } from 'pnmac-universal-components';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Covid from '../components/DisasterRelief/Covid';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../redux/events/events.js';
import PaymentTileLanding from '../components/PaymentTileLanding.js';
import SimplyIOATile from '../components/SimplyIOATile';
import moment from 'moment';
import { getActiveFeatures, showTakeActionDeterminStatus, socialMediaDeterminStatus, windowObject, isSubServicingLoan, isCobrandedLoan } from '../utils.js';
import PaperLessCompile from "../components/Popups/PaperLess";
import Adbuttler from '../Adbuttler/Adbuttler';
import { trackEvent } from "../Tealium";
import { BIO_WORKING } from '../redux/actions/actions';
var styles = {
  card: {
    padding: 10,
    innerStyle: {
      paddingVertical: 0,
      paddingRight: 8,
      minHeight: 280,
      height: "100%"
    }
  }
};
var MarLanding = /** @class */function (_super) {
  __extends(MarLanding, _super);
  function MarLanding() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      long: 0,
      lat: 0,
      imageUrl: '',
      propertyInfo: null,
      inactive: false,
      showBanner: false,
      movrWebStatus: 'Default'
    };
    _this.renderAmorizationAndRefund = function (matches, layout, translations, enabled) {
      var _a, _b, _c;
      var achExist = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _a === void 0 ? void 0 : _a.pendingPayments) === null || _b === void 0 ? void 0 : _b.find(function (s) {
        return s.paymentType == 201309;
      });
      var isCESLoan = ((_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.lienPriorityType) == 2;
      return /*#__PURE__*/React.createElement(View, {
        nativeID: "AmortSceduleTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, layout.banksToAdd && layout.banksToAdd.length > 0 && layout.banksToAdd.find(function (s) {
        return s.isEDisbursementAccount;
      }) ? /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdAmortScheduleTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule,
        subtitle: translations === null || translations === void 0 ? void 0 : translations.Schedule,
        right: function () {
          return PnmacImage(layout.mobile ? "amortization" : require("../assets/amortization.svg"), matches.small ? 40 : 65, "Question mark icon", 'xml', 25);
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.AmortScheduleMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          trackEvent("calculator_engagement");
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, "Amortization Schedule Button Clicked", 5);
          if (_this.props.layout.mobile) {
            PnmacNavigation(__assign({
              action: "".concat(_this.props.layout.pennyHomeUrl, "AmortizationCalculator?ids_token=").concat(_this.props.layout.token),
              wind: true,
              target: "_blank"
            }, _this.props));
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: "/AmortizationCalculator"
              }
            }, _this.props));
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnAmortSchedule"
      }, translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml')))) : getActiveFeatures(layout.features, "View_Edisbursments") ? isCESLoan && !achExist ? /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdAutoPayTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.CESAutoPayTitle,
        right: function () {
          return PnmacImage(layout.mobile ? "autoPay" : require("../assets/autoPay.svg"), matches.small ? 40 : 65, "Dollar sign", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.CESAutoPayMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled || layout.pennyWise,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        labelStyle: {
          lineHeight: 20
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, "CES Pennyhome Page: Enroll Now Link Clicked", 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Payment/Ach"
            }
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnAmortSchedule"
      }, translations === null || translations === void 0 ? void 0 : translations.EnrollNow), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml')))) : /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdRefundsTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.Refunds,
        right: function () {
          return PnmacImage(layout.mobile ? "eDisbursements" : require("../assets/e-disbursements.svg"), matches.small ? 40 : 65, "Dollar sign", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations === null || translations === void 0 ? void 0 : translations.eDisbMessage
      }))), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled || layout.pennyWise,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        labelStyle: {
          lineHeight: 20
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, "Refunds Button Clicked", 0);
          if (_this.props.layout.mobile) {
            if (getActiveFeatures(_this.props.layout.features, "Native_Account_Settings", _this.props.layout.whitelisted)) {
              PnmacNavigation(__assign({
                action: {
                  pathname: "/Account"
                }
              }, _this.props));
            } else {
              PnmacNavigation(__assign({
                action: "".concat(_this.props.layout.pennyHomeUrl, "Account/eDisbursement?ids_token=").concat(_this.props.layout.token),
                wind: true,
                target: "_blank"
              }, _this.props));
            }
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: "/Account/eDisbursement"
              }
            }, _this.props));
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnAmortSchedule"
      }, translations === null || translations === void 0 ? void 0 : translations.Enroll), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml')))) : /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdAmortScheduleTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule,
        subtitle: translations === null || translations === void 0 ? void 0 : translations.Schedule,
        right: function () {
          return PnmacImage(layout.mobile ? "amortization" : require("../assets/amortization.svg"), matches.small ? 40 : 65, "Question mark icon", 'css', 30);
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.AmortScheduleMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          trackEvent("calculator_engagement");
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, "Amortization Schedule Button Clicked", 5);
          if (_this.props.layout.mobile) {
            PnmacNavigation(__assign({
              action: "".concat(_this.props.layout.pennyHomeUrl, "/AmortizationCalculator?ids_token=").concat(_this.props.layout.token),
              wind: true,
              target: "_blank"
            }, _this.props));
          } else {
            PnmacNavigation(__assign({
              action: {
                pathname: "/AmortizationCalculator"
              }
            }, _this.props));
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnAmortSchedule"
      }, translations === null || translations === void 0 ? void 0 : translations.AmortizationSchedule), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Amortization CaretRight icon", 'xml')))));
    };
    return _this;
  }
  MarLanding.prototype.componentDidMount = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.pennyWise) && ((_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.layout) === null || _d === void 0 ? void 0 : _d.logedIn) == true) {
      this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'Marketing Landing Pages Viewed', 0);
      if (((_f = (_e = this.props) === null || _e === void 0 ? void 0 : _e.layout) === null || _f === void 0 ? void 0 : _f.mobile) && ((_h = (_g = this.props) === null || _g === void 0 ? void 0 : _g.layout) === null || _h === void 0 ? void 0 : _h.isAutoLogin)) {
        this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, 'auto login via ' + Platform.OS, 0);
        this.props.dispatch({
          type: BIO_WORKING,
          working: false,
          autoLogin: false
        });
      }
    }
  };
  MarLanding.getDerivedStateFromProps = function (props, state) {
    var _a;
    if (getActiveFeatures(props.layout.features, "movr_In_maintenance", false)) {
      return __assign(__assign({}, state), {
        showBanner: true,
        movrWebStatus: 'InMaintenance'
      });
    }
    var assistanceProgramSummary = (((_a = props.layout) === null || _a === void 0 ? void 0 : _a.currentLoan) || {}).assistanceProgramSummary;
    if (!!(assistanceProgramSummary === null || assistanceProgramSummary === void 0 ? void 0 : assistanceProgramSummary.length)) {
      var assistProgramSummary = assistanceProgramSummary.find(function (x) {
        return x.movrWebStatus;
      });
      return __assign(__assign({}, state), {
        showBanner: !assistProgramSummary ? false : !((assistProgramSummary === null || assistProgramSummary === void 0 ? void 0 : assistProgramSummary.movrWebStatus) !== null && (assistProgramSummary === null || assistProgramSummary === void 0 ? void 0 : assistProgramSummary.movrWebStatus) === 'NoBanner'),
        movrWebStatus: (assistProgramSummary === null || assistProgramSummary === void 0 ? void 0 : assistProgramSummary.movrWebStatus) || 'Default'
      });
    }
    return null;
  };
  MarLanding.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      translations = _b.translations,
      layout = _b.layout,
      modifcation = _b.modifcation;
    var lastPaymentReceivedDate = this.props.layout.lastPaymentReceivedDate;
    var stat = ((_a = layout.selectedLoanAvailability) === null || _a === void 0 ? void 0 : _a.status) || {};
    var showTakeAction = showTakeActionDeterminStatus(stat, modifcation);
    var socialMedia = socialMediaDeterminStatus(stat, modifcation);
    var enabled = !layout.loading;
    var dexpmessage = translations === null || translations === void 0 ? void 0 : translations[layout.DEXPMessagePennyContentKey];
    var allowedSimplyIOAScriptNums = [1, 2, 4];
    var label = layout.isPrivateLabel ? "My Home" : "My PennyHome";
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d, _e;
      return /*#__PURE__*/React.createElement(Fragment, null, ((_a = layout === null || layout === void 0 ? void 0 : layout.loanPreference) === null || _a === void 0 ? void 0 : _a.length) > 0 && !layout.pennyWise ? /*#__PURE__*/React.createElement(PaperLessCompile, {
        matches: matches
      }) : null, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: label
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: matches.large ? "row" : "column",
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(Adbuttler, __assign({
        zoneId: "600391"
      }, _this.props, {
        zone: " Marketing Landing Page ",
        layout: layout,
        FallBack: layout.offers.length > 0 && getActiveFeatures(layout.features, "View_OffersBanner", layout.whitelisted) ? /*#__PURE__*/React.createElement(TouchableOpacity, {
          onPress: function () {
            return PnmacNavigation(__assign({
              action: {
                pathname: "/Offers"
              }
            }, _this.props));
          }
        }, /*#__PURE__*/React.createElement(PnmacCard, {
          style: {
            padding: 15,
            backgroundColor: "#003087",
            marginTop: 10,
            marginRight: 10,
            marginBottom: 20,
            marginLeft: 10
          }
        }, /*#__PURE__*/React.createElement(View, {
          style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }
        }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
          value: translations === null || translations === void 0 ? void 0 : translations.OffersBanner
        })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Image, {
          style: {
            height: 15,
            width: 15,
            tintColor: "#fff"
          },
          source: require('../assets/icon-arrow-right-20.png')
        }))))) : null
      })), _this.state.showBanner && !layout.mobile && layout.selectedLoanNumber !== 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Covid, __assign({
        matches: matches,
        inactive: _this.state.inactive,
        movrWebStatus: _this.state.movrWebStatus
      }, _this.props))) : _this.state.showBanner && layout.selectedLoanNumber !== 0 && getActiveFeatures(_this.props.layout.features, "show_movr_mobile", false) ? /*#__PURE__*/React.createElement(Covid, __assign({
        matches: matches,
        inactive: _this.state.inactive,
        movrWebStatus: _this.state.movrWebStatus
      }, _this.props)) : null, ((_b = layout.DEXPMessagePennyContentKey) === null || _b === void 0 ? void 0 : _b.length) > 1 ? /*#__PURE__*/React.createElement(View, {
        style: {
          paddingTop: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        onClick: function (e) {
          var target = e.target.toString();
          if (target != null && target.indexOf('/Account/ContactInformation') > -1) {
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Account Setting Page ContactInformation Clicked", 0);
          }
        },
        value: dexpmessage,
        navigation: {
          navigate: function () {
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Account Setting Page ContactInformation Clicked", 0);
            PnmacNavigation(__assign({
              action: {
                pathname: "/Account"
              }
            }, _this.props));
          }
        }
      })))) : null, (layout === null || layout === void 0 ? void 0 : layout.showComunicationPreferenceChangeBanner) ? /*#__PURE__*/React.createElement(View, {
        style: {
          paddingTop: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations.CommunicationPreferenceBannerMessage
      })))) : null, _this.state.showBanner && !layout.mobile && layout.selectedLoanNumber !== 0 ? Platform.select({
        web: /*#__PURE__*/React.createElement("hr", {
          style: {
            marginTop: 15,
            marginBottom: 15,
            marginLeft: 15,
            marginRight: 15
          }
        })
      }) : null, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: matches.large ? "row" : "column"
        }
      }, /*#__PURE__*/React.createElement(PaymentTileLanding, __assign({
        matches: matches
      }, _this.props)), /*#__PURE__*/React.createElement(View, {
        nativeID: "PaymentTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.large ? '30%' : '100%',
          padding: 12,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdPaymentTile",
        elvation: 0,
        style: Platform.select({
          web: {
            paddingVertical: 9,
            paddingHorizontal: 16,
            height: 280,
            backgroundColor: "#B5DBBE"
          },
          default: {
            paddingVertical: 9,
            paddingHorizontal: 16,
            minHeight: 280,
            backgroundColor: "#B5DBBE"
          }
        })
      }, /*#__PURE__*/React.createElement(PnmacCardTitle
      // rightStyle={{marginRight:10}}
      , {
        // rightStyle={{marginRight:10}}
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.PaymentReceived,
        subtitle: translations === null || translations === void 0 ? void 0 : translations.Received,
        right: function () {
          return PnmacImage(layout.mobile ? "paymentReceived" : require("../assets/payment-received.svg"), matches.small ? 40 : 65, "PaymentReceived icon", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          marginTop: 20,
          height: 100
        }
      }, /*#__PURE__*/React.createElement(View, null, !lastPaymentReceivedDate ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        color: "#003087",
        value: translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg3
      }))) : /*#__PURE__*/React.createElement(PnmacText, null, (_c = translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg1) !== null && _c !== void 0 ? _c : ''), /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontWeight: '700'
        }
      }, !lastPaymentReceivedDate ? '' : ' ' + moment(lastPaymentReceivedDate).format("MM/DD/YYYY") + '.')), /*#__PURE__*/React.createElement(View, {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        color: "#003087",
        value: !lastPaymentReceivedDate ? '' : translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg2
      })))), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: Platform.select({
          web: {
            flex: 1,
            justifyContent: 'center',
            alignItems: "flex-end"
          },
          default: {
            flex: 1,
            justifyContent: 'center',
            marginBottom: 5,
            alignItems: "flex-end"
          }
        })
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#167027",
        uppercase: true,
        mode: "contained",
        disabled: !enabled,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: Platform.select({
          web: {
            backgroundColor: "#1D8731",
            shadowColor: 'white'
          },
          default: {
            backgroundColor: "#1D8731",
            shadowColor: 'white',
            width: "100%"
          }
        }),
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Loan Activity Button Clicked", 2);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Loan/Activity"
            }
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        idTag: "btnLnActivity",
        style: {
          fontFamily: "Montserrat",
          fontWeight: '700',
          textTransform: 'uppercase',
          color: 'white'
        }
      }, translations === null || translations === void 0 ? void 0 : translations.ViewLoanActivity), PnmacImage(layout.mobile ? "caretRightWhite" : require("../assets/caret-right-white.svg"), 25, "Loan Activity CaretRight icon", 'xml')))))), _this.props.showHomeCards && /*#__PURE__*/React.createElement(View, {
        style: {
          flexGrow: 1,
          display: "flex",
          flexDirection: matches.small ? "column" : "row",
          flexWrap: "wrap"
        }
      }, !layout.isPennymac ? /*#__PURE__*/React.createElement(View, {
        style: {
          width: '100%',
          flexDirection: matches.small ? 'column' : 'row'
        }
      }, layout.isCobranded && getActiveFeatures(layout.features, 'View_Subservicing_Tile') && /*#__PURE__*/React.createElement(View, {
        nativeID: "SubservicingBox",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdSubservicingBox",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        accessibilityRole: "header",
        accessibilityLevel: 1,
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20,
          marginBottom: 0,
          paddingBottom: 0
        },
        title: translations.CobrandingBoxWelcomeToPennymacFamily,
        right: function () {
          return PnmacImage(layout.mobile ? "happyHome" : require("../assets/happy-home.svg"), matches.small ? 40 : 65, "Happy Home icon");
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 0,
          marginTop: 0
        }
      }, layout.mobile ? /*#__PURE__*/React.createElement(View, {
        style: {
          maxHeight: 120,
          paddingTop: 0
        }
      }, PnmacImage(layout.logoUrl, 250, "logo")) : /*#__PURE__*/React.createElement(Image, {
        style: {
          height: 120,
          width: '100%'
        },
        resizeMode: 'center',
        source: {
          uri: layout.logoUrl
        }
      })))), _this.renderAmorizationAndRefund(matches, layout, translations, enabled), /*#__PURE__*/React.createElement(View, {
        nativeID: "EscrowTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdEscrowTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations.SubservicingTileEscrow,
        right: function () {
          return PnmacImage(layout.mobile ? "calculators" : require("../assets/calculators.svg"), matches.small ? 40 : 65, "Calculators", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations.SubservicingTileEscrowInformation)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Center Tile Clicked", 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Loan/Escrow"
            }
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnMortCalc"
      }, translations.SubservicingTileEscrowCenter), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml'))))), getActiveFeatures(_this.props.layout.features, "PrivateLabel_DynamicTile", _this.props.layout.whitelisted) && layout.isPrivateLabel && /*#__PURE__*/React.createElement(View, {
        nativeID: "PrivateLabel_DynamicTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdRefundsTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.PLProductOffersHeader,
        right: function () {
          return PnmacImage(layout.mobile ? "eDisbursements" : require("../assets/e-disbursements.svg"), matches.small ? 40 : 65, "Dollar sign", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        value: translations === null || translations === void 0 ? void 0 : translations.PLProductOffersContent
      }))), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "PrivateLabel Tile Clicked", 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Offers"
            }
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnMortCalc"
      }, translations.PrivateLabelTile), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml'))))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
        nativeID: "ApplyOnlineTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdApplyOnlineTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        accessibilityRole: "header",
        accessibilityLevel: 1,
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.ApplyOnline,
        right: function () {
          return PnmacImage(layout.mobile ? "takeAction" : require("../assets/take-action.svg"), matches.small ? 40 : 65, "Take action icon");
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.ApplyOnlineMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          var _a;
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Apply Online Button Clicked", 3);
          PnmacNavigation(__assign({
            action: "".concat(layout.pennyHomeUrl, "api/main/redirect?goingto=BlendUrl&ids_token=").concat(layout.token, "&&user=").concat((_a = layout.userProfile) === null || _a === void 0 ? void 0 : _a.user_id),
            wind: true,
            target: "_blank"
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnCustMortRate"
      }, translations === null || translations === void 0 ? void 0 : translations.ApplyNow), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "ApplyNow CaretRight icon", 'xml'))))), /*#__PURE__*/React.createElement(View, {
        nativeID: "HomeValueEstimatorTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdHomeValueEstimatorTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.HomeValueEstimator,
        right: function () {
          return PnmacImage(layout.mobile ? "homeValue" : require("../assets/home-value.svg"), matches.small ? 40 : 65, "House icon", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.HomeValueMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Home value estimator Button Clicked", 4);
          if (layout.baseRoute == "/") {} else {
            PnmacNavigation(__assign({
              action: "https://www.pennymac.com/home-value-estimator",
              wind: true,
              target: "_blank"
            }, _this.props));
          }
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnHomeValueEst"
      }, translations === null || translations === void 0 ? void 0 : translations.GetEstimates), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "GetEstimates CaretRight icon", 'xml'))))), /*#__PURE__*/React.createElement(View, {
        nativeID: "CalculatorsTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdCalculatorsTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.Calculators,
        right: function () {
          return PnmacImage(layout.mobile ? "calculators" : require("../assets/calculators.svg"), matches.small ? 40 : 65, "Calculators", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.CalculatorsMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mortgage calculator Button Clicked", 7);
          PnmacNavigation(__assign({
            action: "https://www.pennymac.com/mortgage-calculators",
            wind: true,
            target: "_blank"
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnMortCalc"
      }, translations === null || translations === void 0 ? void 0 : translations.MortgageCalculators), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Tools icon", 'xml'))))), _this.renderAmorizationAndRefund(matches, layout, translations, enabled), allowedSimplyIOAScriptNums.includes((_e = (_d = layout === null || layout === void 0 ? void 0 : layout.simplyIOAData) === null || _d === void 0 ? void 0 : _d.scriptNumber) !== null && _e !== void 0 ? _e : 0) ? /*#__PURE__*/React.createElement(SimplyIOATile, {
        styles: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        },
        matches: matches,
        navigation: _this.props.navigation,
        isEscrow: false
      }) : /*#__PURE__*/React.createElement(View, {
        nativeID: "LearningCenterTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdLearningCenterTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.LearningCenter,
        right: function () {
          return PnmacImage(layout.mobile ? "learningCenter" : require("../assets/learning-center.svg"), matches.small ? 40 : 65, "Chat message icon", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.LearningcenterMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "View our blog Button Clicked", 6);
          PnmacNavigation(__assign({
            action: "https://www.pennymac.com/blog",
            wind: true,
            target: "_blank"
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnClaimBlog"
      }, translations === null || translations === void 0 ? void 0 : translations.PennymacBlog), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Blog CaretRight icon", 'xml'))))), /*#__PURE__*/React.createElement(View, {
        nativeID: "AboutUsTile",
        style: {
          flexGrow: 1,
          flexBasis: matches.small ? "100%" : '30%',
          padding: styles.card.padding,
          flexShrink: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacCard, {
        nativeID: "cdAboutUsTile",
        elvation: 0,
        style: styles.card.innerStyle
      }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        rightStyle: {
          marginRight: 10
        },
        titleStyle: {
          fontWeight: "bold",
          fontSize: !matches.small ? 24 : 20
        },
        title: translations === null || translations === void 0 ? void 0 : translations.AboutUs,
        right: function () {
          return PnmacImage(layout.mobile ? "happyHouse" : require("../assets/happy-house.svg"), matches.small ? 40 : 65, "Happy House", 'css');
        }
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        style: {
          minHeight: 100,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, null, translations === null || translations === void 0 ? void 0 : translations.AboutUseMessage)), /*#__PURE__*/React.createElement(PnmacCardActions, {
        style: {
          alignItems: "center",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        hoverColor: "#cce9f5",
        disabled: !enabled,
        uppercase: true,
        iconSize: 30,
        iconStyles: {
          marginLeft: 10
        },
        style: {
          width: matches.small ? '90%' : '80%',
          margin: 10,
          backgroundColor: "#fff",
          shadowColor: 'white',
          borderWidth: 1,
          borderColor: '#003087',
          alignItems: 'flex-start',
          borderRadius: 6
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "About Us Button Clicked", 7);
          PnmacNavigation(__assign({
            action: "https://www.pennymac.com/about-us",
            wind: true,
            target: "_blank"
          }, _this.props));
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textTransform: 'uppercase'
        },
        idTag: "btnAmortSchedule"
      }, translations === null || translations === void 0 ? void 0 : translations.LearnMore), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Learn More CaretRight icon", 'xml'))))))))));
    });
  };
  return MarLanding;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(MarLanding);